var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgApartment = function SvgApartment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 92 106",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.183 13.101H3.525L0 0h91.708zM7.146 19.056h77.416L84.555 106H52.887V85.937H38.814V106H7.146zm24.635 60.19V65.874H17.71v13.374zm0-20.063V45.81H17.71v13.373zm0-20.063V25.746H17.71V39.12zm21.113 40.127V65.873H38.82v13.374zm0-20.064V45.81H38.82v13.373zm0-20.063V25.746H38.82V39.12zm21.112 40.127V65.873H59.933v13.374zm0-20.064V45.81H59.933v13.373zm0-20.063V25.746H59.933V39.12z"
  })));
};

export default SvgApartment;